import * as React from 'react';
import { Tabs, Tab } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Spinner, Alert } from '@grandvisionhq/iris-ui';
import { withIntl, connect, statusLoading } from '@grandvisionhq/state';
import { fetchDetail, updateCCCAddress, saveCCCAddress, resetCCCAddress, setSubscriptionFormIsEditMode, setSubscriptionFormIsModalOpen } from '../actions.js';
import { getCCCSubscriptionDetailCall, getCCCSubscriptionDetail, getCCCForm } from '../selectors.js';
import CurrentPlanContainer from './CurrentPlan/CurrentPlanContainer.js';
import { Delivery } from './Delivery/Delivery.js';
import { Payments } from './Payments/Payments.js';

const hashNames = [
    'details',
    'delivery',
    'payments'
];
class CCCDetail extends React.Component {
    componentDidMount() {
        const { cccSubscriptionId , fetchDetail: fetchDetail1  } = this.props;
        fetchDetail1({
            cccSubscriptionId
        });
        this.setActiveTab();
    }
    componentDidUpdate() {
        this.setActiveTab();
    }
    render() {
        const { detail , detailCall , intl: { getLabel  } , cccForm , cccSubscriptionId , updateCCCAddress: updateCCCAddress1 , saveCCCAddress: saveCCCAddress1 , resetCCCAddress: resetCCCAddress1 , setSubscriptionFormIsEditMode: setSubscriptionFormIsEditMode1 , setSubscriptionFormIsModalOpen: setSubscriptionFormIsModalOpen1 ,  } = this.props;
        const { activeTabIndex  } = this.state;
        const LABEL_PREFIX = 'account.ccc.details';
        if (detail && detail.id === cccSubscriptionId) {
            var ref;
            return /*#__PURE__*/ React.createElement("div", {
                className: "ccc-details"
            }, /*#__PURE__*/ React.createElement(Heading, {
                variant: "small",
                component: "h1",
                className: "ccc-details__title"
            }, getLabel(`${LABEL_PREFIX}.title`)), Boolean(detail.custom && detail.custom.membershipId) && /*#__PURE__*/ React.createElement("p", {
                className: "ccc-details__membership-id"
            }, `${getLabel(`${LABEL_PREFIX}.membership.id`)}: ${(ref = detail.custom) === null || ref === void 0 ? void 0 : ref.membershipId}`), /*#__PURE__*/ React.createElement("div", {
                className: "ccc-details__tabs"
            }, /*#__PURE__*/ React.createElement(Tabs, {
                onChange: this.handleTabClick,
                activeTabIndex: activeTabIndex
            }, /*#__PURE__*/ React.createElement(Tab, {
                label: getLabel(`${LABEL_PREFIX}.tabs.currentPlan`)
            }), /*#__PURE__*/ React.createElement(Tab, {
                label: getLabel(`${LABEL_PREFIX}.tabs.deliveryDetails`)
            }), /*#__PURE__*/ React.createElement(Tab, {
                label: getLabel(`${LABEL_PREFIX}.tabs.paymentDetails`)
            }))), /*#__PURE__*/ React.createElement("div", {
                className: "ccc-details__body"
            }, activeTabIndex === 0 && /*#__PURE__*/ React.createElement(CurrentPlanContainer, {
                subscription: detail,
                className: "ccc-details__tab"
            }), activeTabIndex === 1 && /*#__PURE__*/ React.createElement(Delivery, {
                cccForm: cccForm,
                onChange: updateCCCAddress1,
                onCancel: resetCCCAddress1,
                onSave: saveCCCAddress1,
                onEditModeChange: setSubscriptionFormIsEditMode1,
                onModalClose: ()=>{
                    setSubscriptionFormIsModalOpen1(false);
                },
                subscription: detail
            }), activeTabIndex === 2 && /*#__PURE__*/ React.createElement(Payments, {
                subscription: detail,
                className: "ccc-payments__tab"
            })));
        } else if (statusLoading(detailCall)) {
            return /*#__PURE__*/ React.createElement(Spinner, {
                "aria-label": getLabel('common.loadingText')
            });
        } else {
            return /*#__PURE__*/ React.createElement(Alert, {
                variant: "error",
                title: getLabel('account.ccc.errors.general'),
                className: "alert-m-default"
            });
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            activeTabIndex: 0
        };
        this.handleTabClick = (index)=>{
            this.setState({
                activeTabIndex: index
            });
            history.replaceState(null, '', `#${hashNames[index]}`);
        };
        this.setActiveTab = ()=>{
            const hash = window.location.hash.replace(/^#/, '');
            const hashIndex = hashNames.indexOf(hash);
            if (hashIndex > -1 && this.state.activeTabIndex !== hashIndex) {
                this.setState({
                    activeTabIndex: hashIndex
                });
            }
        };
    }
}
const WrappedWithIntl = withIntl(CCCDetail);
const mapStateToProps = (state)=>({
        detailCall: getCCCSubscriptionDetailCall(state),
        detail: getCCCSubscriptionDetail(state),
        cccForm: getCCCForm(state)
    })
;
const mapDispatchToProps = {
    fetchDetail,
    updateCCCAddress,
    saveCCCAddress,
    resetCCCAddress,
    setSubscriptionFormIsEditMode,
    setSubscriptionFormIsModalOpen
};
var CCCDetail$1 = connect(mapStateToProps, mapDispatchToProps)(WrappedWithIntl);

export { CCCDetail, CCCDetail$1 as default, mapDispatchToProps, mapStateToProps };
//# sourceMappingURL=CCCDetail.js.map
